import React,{useState} from 'react'
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { GlobalHooks } from '../../../utils/Hooks';
import { useTranslation } from "react-i18next";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { ReactComponent as ContentCopyIcon } from '../../../assets/copy.svg';

export const ApiKey = () => {
  const {cookies} = GlobalHooks()
  const [showMessage, setShowMessage] = useState(false);
  const [messagePosition, setMessagePosition] = useState({ x: 0, y: 0 });
  const {t} = useTranslation()

  const copyText = (event) => {
    navigator.clipboard.writeText(cookies.authToken)
      .then(() => {
        setShowMessage(true);

        const positionX = event.clientX - 400
        const positionY = event.clientY - 50; 

      setMessagePosition({ x: positionX, y: positionY });
        setTimeout(() => {
          setShowMessage(false);
        }, 1000);
      })
      .catch((error) => {
        console.error('Error copying text:', error);
      });
  };

  const handleMouseOver = (event) => {
    const rect = event.target.getBoundingClientRect();
    const positionX = rect.left + rect.width / 2;
    const positionY = rect.top - rect.height;

    setMessagePosition({ x: positionX, y: positionY });
  };

  const colorValue = cookies.ColorTheme === "default" ? "#1976D2" : cookies.ColorTheme === "c2" ? "#002d3d" : cookies.ColorTheme === "c3" ? "#b4c7e5" : cookies.ColorTheme === "c4" ? "#ffcd38" : cookies.ColorTheme === "c5" ? "#8ee5dc"  : "#F32B84" 

  return (
    <div onMouseOver={handleMouseOver} className='key-api-block'>
            <p className='tokenText'>{cookies.authToken}</p>
            {showMessage 
              ? <CheckCircleIcon/>
              :  <ContentCopyIcon className='copy-icon' onClick={(e)=>copyText(e)}/>
            }
        </div>
  )
}
